import React from 'react'
import { Loader } from 'is24-corecss'

const Loading = () => (
  <div className='fix-to-top--fixed grid-flex vertical-center-container grid-align-center grid-justify-center loading-overlay'>
    <Loader size='medium' />
  </div>
)

export default Loading
